interface Props {
  value: number | null | undefined
  height?: number
}

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes == null) return '-'
  const gb = bytes / 1073741824
  if (gb >= 1) return `${gb.toFixed(1)} GB`
  const mb = bytes / 1048576
  return `${mb.toFixed(0)} MB`
}

export function metricColor(value: number | null | undefined): string {
  const pct = value ?? 0
  if (pct >= 90) return '#c62828'
  if (pct >= 70) return '#f57f17'
  return '#2e7d32'
}

export function formatPercent(value: number | null | undefined): string {
  return value == null ? '-' : `${value.toFixed(0)}%`
}

export default function MetricBar({ value, height = 6 }: Props) {
  const pct = value ?? 0

  return (
    <div
      style={{
        height,
        background: '#e0e0e0',
        borderRadius: Math.max(3, height / 2),
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          width: value == null ? 0 : `${Math.min(Math.max(pct, 0), 100)}%`,
          height: '100%',
          background: metricColor(value),
          borderRadius: Math.max(3, height / 2),
          transition: 'width 0.3s',
        }}
      />
    </div>
  )
}
